import { Route, Routes } from "react-router-dom";
import { AnnouncementsPage } from "./page/AnnouncementsPage";
import { AnnouncementDetail } from "./page/AnnouncementDetail";

export default function Announcements() {
  return (
    <Routes>
      <Route path="" element={<AnnouncementsPage />} />
      <Route path=":id" element={<AnnouncementDetail />} />
    </Routes>
  );
}
